module.exports = __webpack_public_path__ + "img/table-delete-icon.74b5b082.svg";